// extracted by mini-css-extract-plugin
export default {"pill":"SelectedPill_pill__iINi1","remove":"SelectedPill_remove__hJbnp","icon":"SelectedPill_icon__6VM98"};